import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './QuickConsult.css';
import { addForm } from '../../api/gwform.js';
import { message } from 'antd';
const QuickConsult = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    remark: '',
    content: '',
    source: '识道造价',
  });
  const handleSubmit = async (e) => {
    e.preventDefault()
    // 这里可以添加表单提交逻辑
    await addForm(formData);
    message.success('感谢您的咨询，我们会尽快与您联系！')
    setFormData({ name: '', phone: '', remark: '', content: '', source: '识道造价' });
  }

  return (
    <section className="quick-consult-section">
      <div className="container">
        <div className="consult-content">
          <div className="consult-info">
            <h2>免费咨询</h2>
            <p>专业顾问为您解答疑问，30分钟内回复</p>
            <div className="contact-methods">
              <div className="contact-item">
                <span className="icon">📞</span>
                <span><a type='tel' href="tel:13957808808">电话：139-5780-8808</a>
                </span>
              </div>
              <div className="contact-item">
                <span className="icon">📧</span>
                <span>邮箱：shidao@yuezhong.com</span>
              </div>
              <div className="contact-item">
                <span className="icon">🕐</span>
                <span>工作时间：周一至周五 9:00-18:00</span>
              </div>
            </div>
            <Link to="/contact" className="btn btn-secondary">查看联系方式</Link>
          </div>
          <form className="consult-form" onSubmit={handleSubmit}>
            <h3>在线咨询</h3>
            <input
              type="text"
              placeholder="您的姓名 *"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
              type="tel"
              placeholder="联系电话 *"
              required
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
            <select
              required
              value={formData.remark}
              onChange={(e) => setFormData({ ...formData, remark: e.target.value })}
            >
              <option value="">请选择咨询类型 *</option>
              <option value="工程造价">工程造价</option>
              <option value="概预算结算审核">概预算结算审核</option>
              <option value="招投标">招投标</option>
              <option value="数智平台">数智平台</option>
              <option value="其他">其他</option>
            </select>
            <textarea
              placeholder="简要描述您的需求"
              rows="4"
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            ></textarea>
            <button type="submit" className="btn btn-primary">提交咨询</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default QuickConsult;



